import Api from "./api";

export const getEnableTagsOnCalleds = async (id) => {
  let data = [];
  await Api.get("/configcalleds/enable-tags-on-calleds")
    .then((result) => {
      data = result.data;
    })
    .catch((err) => {
      data = err;
    });
  return data;
};
